import { Navigate, RouteObject, useLocation } from 'react-router-dom'
import { InsightsPage } from './insights'
import { InsightDetailsPage } from './insight-details'
import { YesterdayTab } from './yesterday'
import { WeeklyTab } from './weekly'
import { InsightsTab } from './utils'

const InsightsIndexRedirect = () => {
    const location = useLocation()

    return (
        <Navigate
            to={{ pathname: InsightsTab.Yesterday, search: location.search }}
            replace
        />
    )
}

export const InsightsRoute: RouteObject[] = [
    {
        path: '/insights',
        element: <InsightsPage />,
        children: [
            { index: true, element: <InsightsIndexRedirect /> },
            { path: 'yesterday', element: <YesterdayTab /> },
            { path: 'weekly', element: <WeeklyTab /> },
        ],
    },
    {
        path: '/insights/details',
        element: <InsightDetailsPage />,
    },
]
